module.exports = __webpack_public_path__ + "static/media/672e09ff-117f-47a9-ad39-2af9420ccb79.57d73e9a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274157/672e09ff-117f-47a9-ad39-2af9420ccb79.woff2
// module id = 1668
// module chunks = 2